// role-based-dashboards — pure redirect-decision helper extracted out of
// `_authenticated.dashboard.tsx`'s `beforeLoad`.
//
// FIX 5 (review) — the route file itself is a TanStack Router file-based
// LAYOUT for every `/dashboard/*` child route (analytics, tickets,
// sms/undelivered, etc.), so `beforeLoad` runs on every one of those child
// navigations too, not just the bare `/dashboard` landing. The gate MUST be
// an exact-pathname check (`pathname === '/dashboard'`), never `startsWith`
// — a regression to `startsWith('/dashboard')` would unconditionally bounce
// a supervisor away from e.g. `/dashboard/analytics`, which they ARE allowed
// to view (nav.ts `requiredRoles: ['org_admin', 'supervisor']`).
//
// Extracted as a pure function (no TanStack Router types involved) so this
// exact-match gate is directly unit-testable without mounting the router.

export type DashboardRoleRedirectTarget = '/dashboard/supervisor' | '/super-admin/overview';

export function resolveDashboardRoleRedirect(
  pathname: string,
  role: string | undefined,
): DashboardRoleRedirectTarget | null {
  // Exact match only — see module comment above.
  if (pathname !== '/dashboard') return null;
  if (role === 'supervisor') return '/dashboard/supervisor';
  if (role === 'super_admin') return '/super-admin/overview';
  return null;
}
